import { useMutation } from '@tanstack/react-query';
import { WithEnterpriseId } from '@mews-commander/types';
import {
    TextMessagingConfigurationUpdateParameters,
    useRepositoryMutation,
    useRepositoryQuery,
} from '@mews-commander/data-access';
import { lt, showSuccessAlert } from '@mews/framework';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { reportConfigurationError } from './actions';

export const useTextMessagingConfiguration = ({ enterpriseId }: WithEnterpriseId) =>
    useRepositoryQuery('textMessagingConfiguration', 'get', { enterpriseId }, { staleTime: 0 });

export const useTextMessagingCofigurationUpdate = ({ enterpriseId }: WithEnterpriseId) => {
    const getConfigurationQuery = useTextMessagingConfiguration({ enterpriseId });
    const dispatch = useCommanderThunkDispatch();

    const { mutateAsync } = useRepositoryMutation('textMessagingConfiguration', 'update');

    return useMutation({
        mutationFn: async (params: TextMessagingConfigurationUpdateParameters) => mutateAsync(params),
        onSuccess: async () => {
            await getConfigurationQuery.refetch();
            showSuccessAlert({ description: lt('SaveSuccessMessage') });
        },
        onError: (error) => {
            if (error instanceof Error) {
                dispatch(reportConfigurationError({ error, extra: { enterpriseId } }));
            }
        },
    });
};
